import React from 'react';
import { PriceDisplay } from './PriceDisplay';
import { CART_URL } from '../utils/constants';
import { CheckIcon } from 'lucide-react';
export function OrderSummary() {
  const items = [{
    name: 'Flanes Sin Horno — Método Completo',
    value: '37'
  }, {
    name: 'Bono #1 — Calculadora Anti-Inflación',
    value: '19'
  }, {
    name: 'Bono #2 — Ventas por WhatsApp Sin Vergüenza',
    value: '17'
  }, {
    name: 'Bono #3 — Kit de Marca Efecto Boutique',
    value: '27'
  }, {
    name: 'Bono #4 — 11 Salsas Irresistibles',
    value: '21'
  }, {
    name: 'Bono #5 — Masterclass Técnica Cero Fallas',
    value: '29'
  }, {
    name: 'Bono #6 — Medidas, envases y rendimiento',
    value: '15'
  }, {
    name: 'Bono #7 — Mini plan de venta semanal',
    value: '19'
  }];
  return <section className="py-10 md:py-16 px-4 bg-white" data-id="element-145">
      <div className="max-w-3xl mx-auto" data-id="element-146">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-center text-brown-dark mb-6 md:mb-10" data-id="element-147">
          Resumen de todo lo que recibes HOY
        </h2>

        <div className="bg-cream-dark rounded-3xl p-5 md:p-10 shadow-xl border border-caramel/30" data-id="element-148">
          <ul className="space-y-3 md:space-y-4 mb-6 md:mb-8" data-id="element-149">
            {items.map((item, i) => <li key={i} className="flex justify-between items-center border-b border-caramel/20 pb-3 last:border-0" data-id="element-150">
                <div className="flex items-center text-gray-800 font-medium" data-id="element-151">
                  <CheckIcon className="w-5 h-5 text-success-green mr-3 flex-shrink-0" data-id="element-152" />
                  <span className={i === 0 ? 'font-bold' : ''} data-id="element-153">
                    {item.name}
                  </span>
                </div>
                <span className="text-gray-400 line-through font-bold ml-4 whitespace-nowrap" data-id="element-154">
                  US${item.value}
                </span>
              </li>)}
          </ul>

          <div className="bg-white rounded-2xl p-5 md:p-8 text-center shadow-inner border border-gray-100" data-id="element-155">
            <p className="text-gray-500 font-bold uppercase tracking-wide mb-2" data-id="element-156">
              VALOR TOTAL: <span className="line-through" data-id="element-157">US$184+</span>
            </p>
            <p className="text-xl text-brown-dark font-bold mb-4" data-id="element-158">
              Hoy obtienes TODO por solo:
            </p>

            <PriceDisplay showOriginal={false} className="mb-6" data-id="element-159" />

            <a href="#pricing-cta" className="block w-full bg-cta-green hover:bg-green-700 text-white font-heading font-bold text-xl md:text-2xl py-5 px-8 rounded-xl shadow-[0_10px_20px_rgba(22,163,74,0.3)] transition-all transform hover:-translate-y-1 mb-4" data-id="element-160">
              AGREGAR AL CARRITO »
            </a>

            <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-xs md:text-sm text-gray-600 font-medium" data-id="element-161">
              <span data-id="element-162">Acceso inmediato por email</span>
              <span className="hidden md:inline" data-id="element-163">•</span>
              <span data-id="element-164">Pago único</span>
              <span className="hidden md:inline" data-id="element-165">•</span>
              <span data-id="element-166">Garantía 7 días</span>
            </div>
          </div>

          <p className="text-center text-xs text-gray-400 mt-6 font-medium uppercase tracking-wider" data-id="element-167">
            Me reservo el derecho de cerrar esta oferta sin aviso previo.
          </p>
        </div>
      </div>
    </section>;
}